(function () {
  document.querySelectorAll('.shop-product').forEach((product) => {
    const variantSelect = product.querySelector('[data-product-variant]');
    const price = product.querySelector('[data-product-price]');
    const addButton = product.querySelector('[data-product-add]');
    const quantity = product.querySelector('input[name="quantity"]');

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      const available = option?.dataset.available === 'true';
      const availableForBackorder = option?.dataset.backorder === 'true';

      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = availableForBackorder
          ? 'Available for back order'
          : available
            ? 'Add to cart'
            : 'Sold out';
      }
    });

    product.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!quantity) return;
        const change = Number(button.dataset.quantityChange);
        quantity.value = Math.max(1, Number(quantity.value || 1) + change);
      });
    });
  });
})();
